module.exports = __webpack_public_path__ + "img/b3.ea269d1.png";